// i18n.js หรือไฟล์การตั้งค่าสำหรับ i18next
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Dashboard": "Dashboard",
      "Alerts": "Alerts",
      "Weather": "Weather",
      "Light Control": "Light Control",
      "Map": "Map",
      "CCTV": "CCTV Camera",
      "LED Screen": "LED Display",
      "Wildfires": "Wildfires",
      "Wildlife": "Wildlife",
      "Water Level": "Water Level",
      "Reports": "Reports",
      "Logout": "Logout",
      "Edit Profile": "Edit Profile",
      "Choose Image": "Choose Image",
      "Cancel": "Cancel",
      "Save": "Save",
      "Confirm Logout": "Are you sure you want to logout?",
      "Section": "Section",
      "EditProfile": "Edit Profile",
      "EditName": "Edit Name",
      "All": "All",
      "Weather Data": "Weather Data",
      "Water Level Data": "Water Level Data",
      "Light Control Data": "Light Control Data",
      "CCTV Data": "CCTV Data",
      "LED Screen Data": "LED Screen Data",
      "Wildfire Data": "Wildfire Data",
      "Wildlife Data": "Wildlife Data",
      "Detail": "Detail of ",
    
    }
  },
  th: {
    translation: {
      "Dashboard": "หน้าหลัก",
      "Alerts": "การแจ้งเตือน",
      "Weather": "สภาพอากาศ",
      "Light Control": "ควบคุมไฟ",
      "Map": "แผนที่",
      "CCTV": "กล้อง CCTV",
      "LED Screen": "จอ LED",
      "Wildfires": "ไฟป่า",
      "Wildlife": "สัตว์ป่า",
      "Water Level": "ระดับน้ำ",
      "Reports": "รายงาน",
      "Logout": "ออกจากระบบ",
      "Edit Profile": "แก้ไข",
      "Choose Image": "เลือกรูปภาพ",
      "Cancel": "ยกเลิก",
      "Save": "บันทึก",
      "Confirm Logout": "คุณแน่ใจหรือไม่ที่จะออกจากระบบ?",
      "Section": "หัวข้อ",
      "EditProfile": "แก้ไขโปรไฟล์",
      "EditName": "แก้ไขชื่อ",
      "All": "ทั้งหมด",
      "Weather Data": "สภาพอากาศ",
      "Water Level Data": "ระดับน้ำ",
      "Light Control Data": "ควบคุมไฟ",
      "CCTV Data": "กล้อง CCTV",
      "LED Screen Data": "จอ LED",
      "Wildfire Data": "ไฟไหม้",
      "Wildlife Data": "สัตว์ป่า",
      "Detail": "รายละเอียดข้อมูล",
      "Wastewater":"น้ำเสีย"
     
    }
  }
};

i18n
  .use(initReactI18next) // ผ่านการใช้ initReactI18next ในการเรียกใช้งาน i18next กับ React
  .init({
    resources, // ทรัพยากรภาษา
    lng: "th", // เปลี่ยนเป็นภาษาไทยเป็นค่าเริ่มต้น
    fallbackLng: "en", // ภาษาสำรองหากไม่พบทรัพยากรสำหรับภาษาปัจจุบัน
    interpolation: {
      escapeValue: false, // ไม่ใช้การ escape ค่าต่างๆ ภายในข้อความ
    },
  });

export default i18n;
